import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { addDivision, AddOrUpdateDivisionApiModel, DivisionModel } from "@tCentro/Services/CENAdminDivisionService";

export interface AddDivisionParameter extends HasOnSuccess<DivisionModel>, HasOnError<string> {
    model: AddOrUpdateDivisionApiModel;
}

type HandlerType = ApiHandler<AddDivisionParameter, { apiResult: DivisionModel }>;

export const AddDivision: HandlerType = async props => {
    try {
        const result = await addDivision(props.parameter.model);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to add division");
        }
    }
};

export const chain = [AddDivision];
const addDivisionData = createHandlerChainRunner(chain, "addDivisionData");
export default addDivisionData;
